module.exports = __webpack_public_path__ + "img/041.b01584af.jpg";